import React,{useState} from "react";
import {
  Box,
  Text,
  Button,
  TextInput,
  DateInput,
  Form,
  FormField,
  CheckBox,
  Select
} from "grommet";
import { withRouter } from "react-router-dom";
import { Search,Filter,Refresh } from "grommet-icons";

function SearchBar(props) {
  const [statusQuery, setStatusQuery] = useState()
  return (
    <Form>
      <Box elevation="large" round pad="medium" margin="small" background={'background-front'}>
        <Box direction="row" justify='between'>
        </Box>
        <Box direction="row" justify="between">
          <Box direction="row">
          <FormField help={<Text size="xsmall" weight={'bold'}>Search AWB Number</Text>} size="small"> <TextInput value={props.awbNumber}  name="searchTerm" icon={<Search />} onChange={(event) => props.setAwbNumber(event.target.value)}/> </FormField> 
          <Box><Button size="small" hoverIndicator primary margin="small" icon={<Search size="small" />} label="Search" onClick={props.queryShipments} /> </Box>
          <FormField help={<Text size="xsmall" margin={{top:'xxsmall'}} weight={'bold'}>Filter Shipments by Date Range</Text>} width='medium'> <DateInput   value={props.dateRange} format="dd/mm/yyyy-dd/mm/yyyy" onChange={props.onChange} margin="small" /> </FormField>
          <Box><Button size='small' hoverIndicator margin="small" icon={<Filter size="small" />} primary label="Filter" onClick={props.filterShipments} /> </Box>
          <FormField help={<Text size="xsmall" margin={{top:'xxsmall'}} weight={'bold'}>Filter Shipments Status</Text>} margin={{left:'small'}}>
          <Select  margin={{left:'small'}} placeholder="Select" closeOnChange={true} value={statusQuery} options={['Awaiting Pickup', 'In Transit', 'Exception', 'Delivered']} onChange={({value} ) => { setStatusQuery(value); props.queryShipmentsStatus(value) }} />
          </FormField>
          </Box>
          <Box direction="row">
          <Box margin='small'><Button size='small' hoverIndicator icon={<Refresh size="small" />} primary label="Reload" onClick={props.reloadShipments} /></Box>
          {(props.user === 'SuperAdmin' ? 
              <Box margin={{top: 'medium'}}><CheckBox checked={props.checked} onChange={event => props.setChecked(event.target.checked)} label='Copy Table Data' alignSelf='end' toggle/></Box> : null
            )}
          </Box>
        </Box>
      </Box>
    </Form>
  );
}

export default withRouter(SearchBar);
